'use client';
import { useComposerState } from '#pplx/frontend/composer-sdk/internal/input-state/useComposerState.js';
/**
 * Reads composer state — layout, focus/IME flags, submit status, draft presence —
 * and its setters, for any component rendered inside a `<Composer>` (the
 * composer's own chrome and plugins alike). Imperative controls live elsewhere:
 * plugin-facing draft mutation and `focus` on `useComposerEditor`, and host
 * operations on the `ComposerHandle` ref.
 */
export function useComposer() {
    return useComposerState();
}
//# sourceMappingURL=useComposer.js.map